import React, { useContext, useEffect } from "react";
import { Button, Text, View } from "react-native";
import { Modal, Portal } from "react-native-paper";
import { useDispatch, useSelector } from "react-redux";
import { trans } from "../../constants/lang";
import { SoundContext } from "../../contexts/sound";
import { actions } from "../../redux";
import {
  selectGoalCoinCountA,
  selectGoalCoinCountB,
  selectIsGameFinish,
} from "../../redux/selectors";

export const FinishModal: React.FC = () => {
  const countA = useSelector(selectGoalCoinCountA);
  const countB = useSelector(selectGoalCoinCountB);

  const isGameFinish = useSelector(selectIsGameFinish);
  const isDraw = countA === countB;
  const winner = countA > countB ? "↓" : "↑";

  const dispatch = useDispatch();

  const { play } = useContext(SoundContext);

  useEffect(() => {
    if (isGameFinish) {
      play("clear");
    }
  }, [isGameFinish]);

  return (
    <Portal>
      <Modal
        visible={isGameFinish}
        contentContainerStyle={{
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <View
          style={{
            backgroundColor: "white",
            borderRadius: 4,
            padding: 24,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {isDraw ? (
            <Text>{trans("drawMessage")}</Text>
          ) : (
            <Text>
              {winner}
              {trans("winMessage")}
            </Text>
          )}
          <Button
            title={trans("playAgain")}
            onPress={() => dispatch(actions.resetGame())}
          ></Button>
        </View>
      </Modal>
    </Portal>
  );
};
